import {
  authReq
} from '@/utils/http'

const getWechatAutoReplyList = (data) => {
  return authReq.get('/api/v1/wechat_auto_reply', {
    page: data.page,
    'page_size': data.pageSize,

    ...data.filters
  })
}

const addWechatAutoReply = (data) => {
  return authReq.post('/api/v1/wechat_auto_reply', {
    userid: data.userId,
    agentid: data.agentId,
    'app_id': data.appId,
    'reply_type': data.replyType,
    'reply_msg': data.replyMsg,
    'key_word': data.keyWord
  })
}

const editWechatAutoReply = (data) => {
  return authReq.put(`/api/v1/wechat_auto_reply/${data._id}`, {
    'reply_type': data.replyType,
    'reply_msg': data.replyMsg,
    'key_word': data.keyWord
  })
}

const deleteWechatAutoReply = (data) => {
  return authReq.delete(`/api/v1/wechat_auto_reply/${data._id}`)
}

export default {
  getWechatAutoReplyList,
  addWechatAutoReply,
  editWechatAutoReply,
  deleteWechatAutoReply
}



// WEBPACK FOOTER //
// ./src/api/wechatAutoReplyApi.js